import React, { useState, useRef, useEffect } from "react";
import { threeDotsIcon } from "assets";
import { Icon } from "components";

// Меню дій рядка таблиці
// actions: [{ label, onClick, disabled, danger }]
const RowActionsMenu = ({ actions = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Закриваємо меню при кліку поза ним
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // Виконує дію та закриває меню
  const runAction = (action) => {
    action();
    setIsOpen(false);
  };

  if (actions.length === 0) return null;

  return (
    <div className="row-actions" ref={menuRef}>
      <button
        className={`row-actions__toggle ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
        title="Дії"
      >
        <Icon src={threeDotsIcon} />
      </button>

      {isOpen && (
        <div className="row-actions__menu">
          {actions.map((action) => (
            <button
              key={action.label}
              className={action.danger ? "danger" : ""}
              onClick={() => runAction(action.onClick)}
              disabled={action.disabled}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RowActionsMenu;
